<template>
<!-- 常规表格 -->
    <div class="normal-table">
        <div class="table-head">{{normalTableconfig.title}}</div>
        <Table border :columns="normalTableconfig.columns" :data="normalTableconfig.data" :class="{'orange':normalTableconfig.orange,'blue':normalTableconfig.blue,'green':normalTableconfig.green}"></Table>
    </div>
</template>
<script>
export default {
    props:{
        normalTableconfig:{
            type:Object
        }
    }

}
</script>
<style lang="less">
.normal-table{
    .table-head{
        line-height:20px;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 10px;
    }
    .orange th{
   background-color: #ff7c4d;
   color:#fff;
}
.blue th{
   background-color: #39b0f9;
   color:#fff;
}
 .green th{
   background-color: #50d27c;
   color:#fff;
}
tr.ark-table-row-hover td{
    background-color:#fff;
}

}
</style>


